document.addEventListener('DOMContentLoaded', function () {
  var colorMap = {
    'altrosa':'#c695a1','beige':'#d6c2aa','bordeaux':'#632d3d','buttercreme':'#f1e4b6',
    'camel':'#b58b64','champagner':'#e9d8bb','creme':'#f2e9dc','dunkelbraun':'#493026',
    'eisblau':'#bfd9e6','espresso':'#3a2923','grau':'#979492','mokka':'#7d6051',
    'nachtblau':'#273249','olivgrün':'#77785b','rot kariert':'repeating-linear-gradient(45deg,#aa333a 0 9px,#e5b5ac 9px 13px,#a2343d 13px 20px)',
    'rot/weiß':'linear-gradient(135deg,#ac343c 0 50%,#f5eee6 50% 100%)',
    'sand':'#cbb99e','schokobraun':'#51352c','schwarz':'#292522','taupe':'#a18e7f',
    'milchig-weiß':'#eee9e3','milchig weiß':'#eee9e3','kaffeebraun':'#b19b8c','helllila':'#c9bbdf','kürbisfarbe':'#ba8062',
    'hellblau':'#c2d8ea','hellgrau':'#c9c9ca','hellbraun':'#b99b87','dunkelgrau':'#52535a','marineblau':'#243a55',
    'aprikose':'#edc6b5','gelb':'#e4c67a','militärgrün':'#65725d','khaki':'#a89d86','korallrosa':'#ec9c9e',
    'hellrosa':'#efd1d4','dunkelrot':'#682e3a','rotwein':'#692c3d','bordeauxrot':'#6c303d',
    'white':'#f6f4ec','black':'#292522','brown':'#6d493b','cream':'#f2e9dc','pink':'#d4a0ac','rosa':'#e8a0ab','khaki':'#b6a38d','blau':'#91b6cf','dunkelgrau':'#45474b','lila':'#a18ab8','weiß':'#f4eee5','rosenrot':'#a94362','hellgrün':'#b9d8bf'
  };
  document.querySelectorAll('[data-ar-swatch]').forEach(function (dot) {
    var key = (dot.getAttribute('data-ar-color-name') || '').trim().toLocaleLowerCase('de-DE');
    dot.style.background = colorMap[key] || '#c6b2a4';
  });

  document.querySelectorAll('.ar-product-v10__form').forEach(function (form) {
    var detail = form.closest('.ar-product-v10__details');
    var data = form.querySelector('[data-ar-variant-data]');
    var idInput = form.querySelector('[data-ar-variant-id]');
    var addButton = form.querySelector('[data-ar-add-button]');
    var availability = form.querySelector('[data-ar-variant-availability]');
    var price = detail.querySelector('[data-ar-variant-price]');
    var groups = Array.prototype.slice.call(form.querySelectorAll('[data-ar-option-group]'));
    var variants = [];
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    function selectedValues() {
      return groups.map(function (group) {
        var chosen = group.querySelector('[data-ar-choice].is-selected');
        return chosen ? chosen.getAttribute('data-ar-option-value') : '';
      });
    }
    function updateVariant() {
      var selected = selectedValues();
      var match = variants.find(function (variant) {
        return variant.options && variant.options.length === selected.length && variant.options.every(function (value, index) {
          return value === selected[index];
        });
      });
      if (!match) {
        idInput.value = '';
        addButton.disabled = true;
        addButton.textContent = 'Kombination nicht verfügbar';
        availability.textContent = 'Diese Kombination ist derzeit nicht verfügbar.';
        return;
      }
      idInput.value = match.id;
      addButton.disabled = !match.available;
      addButton.textContent = match.available ? 'In den Warenkorb →' : 'Aktuell nicht verfügbar';
      availability.textContent = match.available ? 'Für diese Variante verfügbar' : 'Diese Variante ist derzeit ausverkauft.';
      if (price && Number.isFinite(Number(match.price))) {
        var euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
        var salePrice = price.querySelector('[data-ar-sale-price]');
        var oldPrice = price.querySelector('[data-ar-original-price]');
        if (salePrice && oldPrice) {
          salePrice.textContent = euro.format(Math.round(Number(match.price) * 0.85) / 100);
          oldPrice.textContent = euro.format(Number(match.price) / 100);
        } else { price.textContent = euro.format(Number(match.price) / 100); }
      }
    }
    function choose(group, button) {
      group.querySelectorAll('[data-ar-choice]').forEach(function (choice) {
        var active = choice === button;
        choice.classList.toggle('is-selected', active);
        choice.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      var label = group.querySelector('[data-ar-option-label]');
      if (label) label.textContent = button.getAttribute('data-ar-option-value') || '';
      updateVariant();
    }
    groups.forEach(function (group) {
      group.querySelectorAll('[data-ar-choice]').forEach(function (button) {
        button.addEventListener('click', function () { choose(group, button); });
      });
    });
    updateVariant();

    var dialog = detail.querySelector('[data-ar-size-advisor]');
    if (dialog) {
      var result = dialog.querySelector('[data-ar-size-result]');
      var chartElement = dialog.querySelector('[data-ar-size-chart]');
      var chart = null;
      try { chart = JSON.parse(chartElement.textContent); } catch (e) {}
      function showResult(message, size) {
        result.replaceChildren();
        var p = document.createElement('p');
        p.textContent = message;
        result.appendChild(p);
        if (size) {
          var group = groups.find(function (g) { return /größe|groesse|size/i.test(g.getAttribute('data-ar-option-name') || ''); });
          var target = group && Array.prototype.slice.call(group.querySelectorAll('[data-ar-choice]')).find(function (b) {
            return b.getAttribute('data-ar-option-value') === size;
          });
          if (target) {
            var select = document.createElement('button');
            select.type = 'button';
            select.className = 'ar-size-advisor__use-size';
            select.textContent = 'Größe ' + size + ' auswählen →';
            select.addEventListener('click', function () {
              choose(group, target);
              dialog.close();
              target.focus();
            });
            result.appendChild(select);
          }
        }
        result.hidden = false;
      }
      var hasVerifiedChart = !!(chart && Array.isArray(chart.sizes) && chart.sizes.length);
      if (!hasVerifiedChart) {
        dialog.querySelector('.ar-size-advisor__fields').hidden = true;
        dialog.querySelector('.ar-size-advisor__hint').hidden = true;
        dialog.querySelector('[data-ar-calculate-size]').hidden = true;
      }
      detail.querySelectorAll('[data-ar-open-size-advisor]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          result.hidden = true;
          if (!hasVerifiedChart) {
            showResult('Für diesen Artikel liegt noch keine bestätigte Größentabelle vor. Wir möchten keine Größe raten. Bitte frage unseren Support nach den Produktmaßen.');
          }
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
        });
      });
      dialog.querySelector('[data-ar-close-size-advisor]').addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
      dialog.querySelector('[data-ar-calculate-size]').addEventListener('click', function () {
        if (!chart || !Array.isArray(chart.sizes) || chart.sizes.length === 0) {
          showResult('Für diesen Artikel liegt noch keine verifizierte Größentabelle vor. Wir möchten keine Größe raten. Bitte frage unseren Support nach den Produktmaßen.');
          return;
        }
        var measurements = {};
        dialog.querySelectorAll('[data-ar-measure]').forEach(function (input) {
          var value = Number(input.value.replace(',', '.'));
          if (input.value.trim() !== '' && Number.isFinite(value) && value >= 40 && value <= 200) {
            measurements[input.getAttribute('data-ar-measure')] = value;
          }
        });
        if (Object.keys(measurements).length === 0) {
          showResult('Bitte gib mindestens einen gültigen Körperumfang in cm ein.');
          return;
        }
        var matches = [];
        chart.sizes.forEach(function (row) {
          if (!row || !row.size) return;
          var fields = ['bust', 'waist', 'hip'];
          var comparisons = 0;
          var score = 0;
          var fits = true;
          fields.forEach(function (key) {
            if (!Object.prototype.hasOwnProperty.call(measurements, key)) return;
            var range = row[key];
            if (!Array.isArray(range) || range.length !== 2) return;
            var lo = Number(range[0]), hi = Number(range[1]);
            if (!Number.isFinite(lo) || !Number.isFinite(hi) || hi < lo) return;
            comparisons++;
            var value = measurements[key];
            if (value < lo || value > hi) fits = false;
            var center = (lo + hi) / 2;
            score += Math.abs(value - center) / Math.max(hi - lo, 1);
          });
          if (comparisons > 0 && fits) matches.push({ size: String(row.size), score: score, comparisons: comparisons });
        });
        matches.sort(function (a, b) { return b.comparisons - a.comparisons || a.score - b.score; });
        if (matches.length) {
          var best = matches[0];
          var tied = matches.length > 1 && matches[1].comparisons === best.comparisons && Math.abs(matches[1].score - best.score) < 0.12;
          if (tied) {
            showResult('Deine Maße liegen zwischen Größe ' + best.size + ' und ' + matches[1].size + '. Bitte prüfe die Passform oder frage unseren Support.');
          } else {
            showResult('Unsere Größenempfehlung für diesen Artikel: ' + best.size + '. Grundlage sind die hinterlegten Körpermaßbereiche.', best.size);
          }
        } else {
          showResult('Für deine angegebenen Maße gibt es keine eindeutige Übereinstimmung in der hinterlegten Größentabelle. Bitte kontaktiere unseren Support.');
        }
      });
    }
  });

  document.querySelectorAll('[data-ar-gallery]').forEach(function (gallery) {
    var hero = gallery.querySelector('.ar-product-v10__hero-image');
    if (!hero) return;
    gallery.querySelectorAll('[data-ar-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-image-src');
        if (!src) return;
        hero.src = src;
        hero.removeAttribute('srcset');
        hero.removeAttribute('sizes');
        hero.alt = thumb.getAttribute('data-image-alt') || hero.alt;
        gallery.querySelectorAll('[data-ar-thumb]').forEach(function (b) {
          var active = b === thumb;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });
  });

  var trigger = document.querySelector('[data-ar-search-toggle]');
  var panel = document.querySelector('[data-ar-search-panel]');
  if (trigger && panel) {
    var closeButton = panel.querySelector('[data-ar-search-close]');
    var searchForm = panel.querySelector('[data-ar-search-form]');
    var input = panel.querySelector('[data-ar-search-input]');
    var suggestions = panel.querySelector('[data-ar-search-suggestions]');
    var popular = panel.querySelector('[data-ar-search-popular]');
    var timer = null;
    var controller = null;
    function closeSearch() {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-label', 'Suche öffnen');
    }
    function openSearch() {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      trigger.setAttribute('aria-label', 'Suche schließen');
      input.focus();
    }
    trigger.addEventListener('click', function () {
      if (panel.hidden) openSearch(); else closeSearch();
    });
    closeButton.addEventListener('click', function () { closeSearch(); trigger.focus(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { closeSearch(); trigger.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !panel.contains(e.target) && !trigger.contains(e.target)) closeSearch();
    });
    function showSuggestions(products, term) {
      suggestions.replaceChildren();
      if (!products.length) {
        var empty = document.createElement('p');
        empty.className = 'ar-search-panel__empty';
        empty.textContent = 'Keine passenden Produkte gefunden.';
        suggestions.appendChild(empty);
      } else {
        var heading = document.createElement('p');
        heading.className = 'ar-search-panel__suggestions-heading';
        heading.textContent = 'PRODUKTE';
        suggestions.appendChild(heading);
        var list = document.createElement('div');
        list.className = 'ar-search-panel__list';
        products.forEach(function (product) {
          var url;
          try { url = new URL(product.url, window.location.origin); } catch (e) { return; }
          if (url.origin !== window.location.origin) return;
          var link = document.createElement('a');
          link.href = url.pathname + url.search;
          link.className = 'ar-search-panel__result';
          if (product.featured_image && product.featured_image.url) {
            var img = document.createElement('img');
            img.src = product.featured_image.url;
            img.alt = '';
            img.loading = 'lazy';
            link.appendChild(img);
          }
          var name = document.createElement('span');
          name.textContent = product.title;
          link.appendChild(name);
          list.appendChild(link);
        });
        suggestions.appendChild(list);
      }
      var all = document.createElement('a');
      all.className = 'ar-search-panel__all';
      all.href = '/search?q=' + encodeURIComponent(term) + '&type=product';
      all.textContent = 'Alle Ergebnisse ansehen →';
      suggestions.appendChild(all);
    }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      if (controller) controller.abort();
      var term = input.value.trim();
      suggestions.replaceChildren();
      popular.hidden = term.length >= 2;
      if (term.length < 2) return;
      timer = setTimeout(function () {
        controller = new AbortController();
        var raw = searchForm.getAttribute('data-ar-suggest-url') || '/search/suggest.json';
        var url = new URL(raw, window.location.origin);
        if (!url.pathname.endsWith('.json')) url.pathname += '.json';
        url.searchParams.set('q', term);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '5');
        fetch(url.toString(), { signal: controller.signal })
          .then(function (response) { if (!response.ok) throw new Error('search'); return response.json(); })
          .then(function (data) {
            if (input.value.trim() !== term || panel.hidden) return;
            var products = data && data.resources && data.resources.results && data.resources.results.products || [];
            showSuggestions(products, term);
          })
          .catch(function (e) {
            if (e.name !== 'AbortError') {
              suggestions.replaceChildren();
              var note = document.createElement('p');
              note.className = 'ar-search-panel__empty';
              note.textContent = 'Drücke Enter, um alle Produkte zu durchsuchen.';
              suggestions.appendChild(note);
            }
          });
      }, 240);
    });
  }
});